module.exports = __webpack_public_path__ + "img/ic_cotações.13eb64a2.svg";